import { render, staticRenderFns } from "./LogosContentBlock.vue?vue&type=template&id=469b6885"
import script from "./LogosContentBlock.vue?vue&type=script&lang=ts"
export * from "./LogosContentBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports